export const BASE = {
  name: 'feedback',
  path: '/sites/:siteId/feedback',
};

export const LIST = {
  name: 'feedback.list',
  path: `${BASE.path}/list`,
};

export const RESPONSES_DEFAULT = {
  name: 'feedback.responses_default',
  path: `${BASE.path}/responses`,
};

export const RESPONSES = {
  name: 'feedback.responses',
  path: `${BASE.path}/responses/:feedbackWidgetId`,
};

export const RESPONSE = {
  name: 'feedback.responses',
  path: `${BASE.path}/responses/:feedbackWidgetId?frid`,
};

export const CREATE_BASE = {
  name: 'feedback.create',
  path: `${BASE.path}/create/`,
};

export const CREATE = {
  name: 'feedback.create',
  path: `${BASE.path}/create/:copyId`,
};

export const EDIT_BASE = {
  name: 'feedback.edit',
  path: `${BASE.path}/edit/:feedbackWidgetId`,
};

export const EDIT = {
  name: 'feedback.edit',
  path: `${EDIT_BASE.path}/:activeFlowSection`,
};
